import React, { useEffect, useState,useMemo } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import LeadListFilter from './LeadListFilter';
import LeadListTable from './LeadListTable';
import { useDispatch } from 'react-redux';
import { getInsuranceList,bulkLeadAssignee } from '../../src/store/slices/insurance';
import FullPageLoader from '../../src/common/FullPageLoader'; 
import { KEY_ACTIVE_TAB_MAP,MANAGER_LEVEL_IDS,COUNTRY_CODE,APP_COUNTRY,MAX_LEAD_ASSIGN_COUNT } from '../../src/config/constant';
import { getMasterConfig, getPartnerList,downloadSoa,getPaymentMethodData } from '../../src/store/slices/common';
import { getRoleListing } from '../../src/store/slices/RoleUser';
import secureStorage from "@src/config/encrypt";
import * as HELPER from "@src/config/helper";
import Modal from "@src/common/ModalPopup";
import BulkImportModal from "../lead/common/BulkImportModal";
import { toast } from "react-toastify";
import { useLanguage } from "../../src/context/LanguageContext";
import ConfirmPopUp from '../../src/common/ConfirmPopUp';
import LeadAssigneePopup from '../../src/lead/common/LeadAssignPopup';
import { useSelector } from 'react-redux';
import ApplicationTypeChips, { getApplicationTypeMap, getFiltersWithApplicationType } from '../../src/common/ApplicationTypeChips';

interface SelectedLead {
  lead_id: number;
}

const LeadList = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({});
  const [tabCount, setTabCount] = useState<any>({});
  const [insuranceList, setInsuranceList] = useState<any>([]);
  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [masterConfig, setMasterConfig] = useState<any>({});
  // eslint-disable-next-line
  const [listSort, setListSort] = useState<any>({});
  const [assignUsers, setAssignedUsers] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>('all');
  const [sortVal, setSortVal] = useState<any>('due_date_desc');
  const [selectedLeadView, setSelectedLeadView] = useState<any>('my');
  const [selectedLeadApplicationType, setSelectedLeadApplicationType] = useState<string>('b2c');
  const [partnerList, setPartnerList] = useState<any>([]);
  const [bulkUploadModal, setBulkUploadModal] = useState<any>(false);
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const roleId = authUserInfo?.user_data?.assigned_role_ids;
  const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name || "");
  const IS_COLLECTION_AGENT = (() => {
    switch (roleName) {
      case "COLLECTIONS_AGENT":
        return true;
      default:
        return false;
    }
  })();
  const showLeadViewChips = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && IS_COLLECTION_AGENT;
  const { translations } = useLanguage();
  const [paymentMethod, setPaymentMethod] = useState<any>([]);
  const [selectedLeads, setSelectedLeads] = useState<SelectedLead[]>([]);
  const [isAllLeadsSelected, setIsAllLeadsSelected] = useState<boolean>(false);
  const [showConfirmation,setShowConfirmation] = useState<boolean>(false);
  const [showLeadAssignPopup,setShowLeadAssignPopup] = useState<boolean>(false);
  const [agentId,setAgentId] = useState<number>(0);
  const insurerList = useSelector((state: any) => state.common.partner);
  const formatLeadCount = (count: any) => {
    const numericCount = Number(count || 0);
    return Number.isFinite(numericCount) ? numericCount.toLocaleString('en-US') : '0';
  };
  const leadViewChips = [
    { key: 'all', label: 'All Leads', count: showLeadViewChips ? (tabCount?.final_total_leads ?? tabCount?.all ?? 0) : (tabCount?.all || 0) },
    { key: 'my', label: 'My Leads', count: tabCount?.my_lead_count || 0 },
  ];
  const leadApplicationTypeMap = useMemo(() => getApplicationTypeMap(masterConfig), [masterConfig]);


  const partnerMap = useMemo(() => {
    const map: Record<number, string> = {};
    insurerList.forEach((p: any) => {
      map[+p.value] = p.label;
    });
    return map;
  }, [insurerList]);

  useEffect(() => {
    if (!insurerList || insurerList.length === 0) {
      getPartners();
    }
    getMasterConfigApi();
    if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
      getInsuranceListing({page_number: 1});
    }
    getAssignedUsers();
    if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID){
      getPaymentMethod();
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (insurerList.length > 0 && COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID) {
      getInsuranceListing({ page_number: 1 });
    }
  }, [insurerList]);


  //GET INSURANCE LIST API
  const getLeadViewFilters = (filters: Record<string, any> = {}, leadView = selectedLeadView) => {
      const filtersWithView = { ...filters };

      if (showLeadViewChips) {
        if (leadView === 'my') {
          filtersWithView.assign_user_id = authUserInfo?.user_data?.id;
        } else {
          delete filtersWithView.assign_user_id;
        }
      }

      return filtersWithView;
  };

  const getLeadApplicationTypeFilters = (filters: Record<string, any> = {}, applicationType = selectedLeadApplicationType) => {
      return getFiltersWithApplicationType(filters, applicationType, leadApplicationTypeMap);
  };

  const getInsuranceListing = (params: any,isCall=true, leadView = selectedLeadView, applicationType = selectedLeadApplicationType) => {
      let filters: Record<string, any> = {
          apiType: 1, // 1 for insurance_leads
          page_number: params?.page_number ?? 1,
          activeTab,
          sort: sortVal,
          ...params,
      }
      filters = getLeadViewFilters(filters, leadView);
      filters = getLeadApplicationTypeFilters(filters, applicationType);
      setLoading(true);
      dispatch(getInsuranceList(filters)).then((res: any) => {
          if (res && res.status === 200) {
              setLoading(false);
              setPaginationData(res.pagination);
              setTabCount(res.tabCount);
              if (insurerList.length > 0 && COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID) {
                const updatedData = res.data.map((item: any) => {
                  return {
                    ...item,
                    insurer_name: partnerMap[item.insurer_id] || ""
                  };
                });
                setInsuranceList(updatedData);
              }else{
                setInsuranceList([...res.data]);
              }
              if(isAllLeadsSelected && isCall){
                const allSelected: SelectedLead[] = res.data.map((lead: any) => ({
                  lead_id: lead.leadId,
                }));
                setSelectedLeads(allSelected);
              }else{
                setSelectedLeads([]);
              }
          }
      }).catch((err: Error) => {
          setLoading(false)
      })
  }

  const getMasterConfigApi = () => {
    setLoading(true);
    dispatch(getMasterConfig()).then((res: any) => {
      if (res && res.status === 200) {
        if (res.data) {
          setMasterConfig(res.data);
          setListSort(res.data['lead_sorting_filter'][0]);
        }
      }
    }).catch((err: Error) => {
      setLoading(false);
    })
  }

  const getAssignedUsers = () => {
    dispatch(getRoleListing.getAssignedUsers({})).then((res: any) => {
      if (res && res.status === 200) {
        setAssignedUsers(res.data.map((user: any) => { return { label: `${user.firstname} ${user.lastname}`, value: user.id } }));
      }
    }).catch((err: any) => {
      setLoading(false);

    })
  }

  const getPartners = () => {
    dispatch(getPartnerList()).then((res: any) => {
      if (res && res.status === 200) {        
        if (res.data) {
          const data = Array.isArray(res?.data) ? res.data : [];
          const updatedList = data.map((item: any) => ({
            ...item,
            isDisabled: false
          }));
          setPartnerList(updatedList);
        }
      }
    }).catch((err: Error) => {
      setLoading(false);
    })
  }

  const activeTabHandler = (tab: any) => {
    if (!tab) return;    
    const activeTab = KEY_ACTIVE_TAB_MAP[tab];    
    if (activeTab) {
      getInsuranceListing({page_number: 1, activeTab, ...selectedFilters},false);
      setActiveTab(activeTab);
      setSelectedLeads([])
    }
  } 

  const handleLeadViewChange = (leadView: any) => {
    if (selectedLeadView === leadView) return;
    setSelectedLeadView(leadView);
    setSelectedLeads([]);
    setIsAllLeadsSelected(false);
    getInsuranceListing({ page_number: 1, ...selectedFilters }, false, leadView);
  }

  const handleLeadApplicationTypeChange = (applicationType: string) => {
    if (selectedLeadApplicationType === applicationType) return;
    setSelectedLeadApplicationType(applicationType);
    setSelectedLeads([]);
    setIsAllLeadsSelected(false);
    getInsuranceListing({ page_number: 1, ...selectedFilters }, false, selectedLeadView, applicationType);
  }

  const downloadSoaData = async () => {
    try {
      if (!selectedFilters.agency_names || selectedFilters.agency_names.length === 0) {
        toast.error(translations.Remittance?.["DOWNLOAD_SOA_ERROR"] || translations.commonMsg?.loading);
        return;
      }
      setLoading(true);
      const payload = {agency_id : selectedFilters.agency_names};
      await downloadSoa(payload);
    } catch (error) {
      console.error("Error downloading SOA:", error);
    } finally {
      setLoading(false);
    }
  }

  const getPaymentMethod = async() => {
    dispatch(getPaymentMethodData()).then((res: any) => {
      if (res && res.status === 200) {        
        if (res.data) {
          setPaymentMethod(res.data);
        }
      }
    }).catch((err: Error) => {
      setLoading(false);
    })
  }

  const updateBulkAssignee = async () => {
    try{
      if(selectedLeads.length === 0){
          toast.error(translations.Insurance?.['NO_LEAD_SELECTED'] || translations.commonMsg?.loading);
          return;
      }
      if(isAllLeadsSelected){
        if(tabCount[activeTab] > MAX_LEAD_ASSIGN_COUNT){
          toast.error(`${translations.Insurance?.['MAX_ASSIGN_LEAD_LIMIT'] || translations.commonMsg?.loading} ${MAX_LEAD_ASSIGN_COUNT}`);
          return;
        }
      }
      setShowLeadAssignPopup(true);
    }catch (error) {
      console.error("Error In Update Assignee:", error);
    } finally {
      setLoading(false);
    }
  }
  

  const handleSubmit = async () => {
      try{
        let paylaod:any = {
          lead_type:'insurance',
          assigned_user_id : +agentId,
          isAllLeadsSelected : isAllLeadsSelected,
          data_filter : getLeadApplicationTypeFilters(getLeadViewFilters(selectedFilters))
        };
        if(isAllLeadsSelected){
          paylaod.activeTab = activeTab;
        }else{
          paylaod.leads = selectedLeads
        }
        setLoading(true);
        const response:any = await bulkLeadAssignee(paylaod);
        if (response?.status === 200) {
          setShowConfirmation(false)
          setSelectedLeads([]);
             let apiParams = {
            ...selectedFilters
          }
          setIsAllLeadsSelected(false);
          getInsuranceListing(apiParams,false)
        }
      }catch (error) {
          console.error("Error while updating EMI detail:", error);
      }finally {
        // setLoading(false);
      }
  }

  return (
    <>
      <FullPageLoader show={loading} />
      {showLeadAssignPopup && <LeadAssigneePopup from={"Insurance"} showLeadAssignPopup={showLeadAssignPopup} setShowLeadAssignPopup={setShowLeadAssignPopup} assignUsers={assignUsers} setShowConfirmation={setShowConfirmation} setAgentId={setAgentId}/>}
      {showConfirmation === false ? ("") : (
            <ConfirmPopUp
                confirmNo={() => {
                  setShowConfirmation(false);
                  setShowLeadAssignPopup(false);
                  setSelectedLeads([]);
                }}
                confirmYes={handleSubmit}
                message={`All the ${isAllLeadsSelected === false ? selectedLeads.length : ''} records will get updated. Do you wish to continue ?`}
                isConfirmNotVisible={true} 
                from={"Insurance"}
            />
        )}
      {
            bulkUploadModal
            &&
            <div className={`calculator-popup davition-popup bulk-upload-popup`}>
                <Modal show={bulkUploadModal} handleClose={() => setBulkUploadModal(false)} from="bulkUpload">
                    <div className="modal-header bulk-modal-header">
                        <h2>{`Bulk Upload Application`}</h2>
                    </div>
                    <div className="modal-body" >
                        <div className="bulk-upload-history-content">
                            <BulkImportModal setUpdateModal={{setUpdateModal:bulkUploadModal, type:"bulk_upload", title: "Bulk Upload Application"}} type="collectionBulkUploadSoa" mode_of_payment={masterConfig.payment_method} closeBulkUploadModal={()=>setBulkUploadModal(false)}/>
                            
                        </div>
                        
                            
                    </div>
                </Modal>
            </div>
        }
      <div className='main-outer'>
        <div className="lead-list-outer container-fluid ">
          <div>
            <div className="top-heading top-heading-btn">
              <h1>Insurance Leads</h1>
              {
                (MANAGER_LEVEL_IDS.includes(roleId)) &&
                <div className="soa-button-group">
                    <button className="btn-line btn-export" onClick={updateBulkAssignee}>
                      {translations.Insurance?.['Update_Assignee'] || translations.commonMsg?.loading}
                    </button>
                    {COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH &&
                      <>
                        <button className="btn-line btn-export" onClick={() => setBulkUploadModal(!bulkUploadModal)}>
                          <i className="ic-save_alt m-sm-r"></i>
                          Upload SOA
                        </button>
                        <button className="btn-line btn-export" onClick={downloadSoaData}>
                          <i className="ic-save_alt m-sm-r"></i>
                          Download SOA
                        </button>
                      </>
                    }
                </div>
              }
            </div>

            <div className="loan-filter-bg">
              <div className="top-filter-bg">
                <LeadListFilter partnerList={partnerList} config={masterConfig} paymentMethod={paymentMethod} submitHandler={(filterParams: any) => { getInsuranceListing(filterParams) }} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} assignUsers={assignUsers}/>
              </div>
            </div>

            <div className="lead-list-table-outer">
              <ApplicationTypeChips
                selectedApplicationType={selectedLeadApplicationType}
                paginationData={tabCount}
                onChange={handleLeadApplicationTypeChange}
              />
              {showLeadViewChips && (
                <div className="lead-view-chip-outer">
                  <span className="lead-view-label">VIEW</span>
                  <div className="lead-view-chip-list">
                    {leadViewChips.map((chip) => (
                      <button
                        key={chip.key}
                        type="button"
                        className={`lead-view-chip ${selectedLeadView === chip.key ? 'active' : ''}`}
                        onClick={() => handleLeadViewChange(chip.key)}
                      >
                        {chip.label}
                        <span>{formatLeadCount(chip.count)}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <Tab.Container id="lead-tabs" defaultActiveKey="first">
                {
                  COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH ? 
                  <Nav variant="pills" className="flex-column nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                    <div className="tab-list">
                      <Nav.Item>
                        <Nav.Link eventKey="first">All <span>({(tabCount && tabCount['all']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Due in 14 Days <span>({(tabCount && tabCount['due_in_14']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Overdue <span>({(tabCount && tabCount['overdue']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                      {!IS_COLLECTION_AGENT &&  <Nav.Link eventKey="fourth">About to Expire <span>({(tabCount && tabCount['about_to_expire']) || 0})</span></Nav.Link>
                      }
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fifth">Fully Paid <span>({(tabCount && tabCount['fully_paid']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="sixth">Overpaid <span>({(tabCount && tabCount['overpaid']) || 0})</span></Nav.Link>
                      </Nav.Item>
                    </div>
                    {/* <div className="sorting-filter-cls">
                      <ReactSelect
                        options={masterConfig['lead_sorting_filter']}
                        handleChange={(e: any, fieldKey: string) => sortByhandleChange(e)}
                        value={listSort} 
                        fieldKey="" 
                        disableMargin={true} 
                        placeholder={""}
                      />
                    </div> */}
                  </Nav>
                  :
                  <Nav variant="pills" className="flex-column nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                    <div className="tab-list">
                      <Nav.Item>
                        <Nav.Link eventKey="first">All <span>({(tabCount && tabCount['all']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Outstanding <span>({(tabCount && tabCount['outstanding']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Unpaid <span>({(tabCount && tabCount['unpaid']) || 0})</span></Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fourth">Expired <span>({(tabCount && tabCount['expired']) || 0})</span></Nav.Link>
                      </Nav.Item>
                    </div>
                    {/* <div className="sorting-filter-cls">
                      <ReactSelect
                        options={masterConfig['lead_sorting_filter']}
                        handleChange={(e: any, fieldKey: string) => sortByhandleChange(e)}
                        value={listSort} 
                        fieldKey="" 
                        disableMargin={true} 
                        placeholder={""}
                      />
                    </div> */}
                  </Nav>
                }

                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fourth">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fifth">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                  <Tab.Pane eventKey="sixth">
                    <LeadListTable insuranceList={insuranceList} paginationData={paginationData} selectedFilters={selectedFilters} getInsuranceListing={getInsuranceListing} assignUsers={assignUsers} setSortVal={setSortVal} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} setIsAllLeadsSelected={setIsAllLeadsSelected}/>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default LeadList;
